import React, { Component } from 'react'
import PropTypes from 'prop-types'
import update from 'immutability-helper'

import PageParamBuilder from './page-param-builder'

// Antons note: HOCs are named with lower case and kebab-case for folders, just like redux's connect etc.
// This is to avoid confusion with react components, since they are just functions
// check out https://reactjs.org/docs/higher-order-components.html

function pageableTable(WrappedComponent) {
  return class extends Component {
    // Using proptypes as static since the class is unnamed
    // eslint-disable-next-line react/static-property-placement
    static propTypes = {
      onLoadPagingData: PropTypes.func,
      pagination: PropTypes.object,
      lastSort: PropTypes.shape({
        headerName: PropTypes.string,
        direction: PropTypes.string,
      }),
    }

    // eslint-disable-next-line react/static-property-placement
    static defaultProps = {
      onLoadPagingData: () => {},
      pagination: {},
      lastSort: {
        headerName: '',
        direction: '',
      },
    }

    constructor(props) {
      super(props)
      const pageInfo = new PageParamBuilder()
      pageInfo.page = this.props.pagination.pageNumber
      pageInfo.size = this.props.pagination.size
      pageInfo.count = this.props.pagination.totalPages
      pageInfo.sortList =
        this.props.lastSort && this.props.lastSort.headerName !== ''
          ? [
              `${this.props.lastSort.headerName},${this.props.lastSort.direction}`,
            ]
          : []

      this.state = { pageInfo }
    }

    UNSAFE_componentWillReceiveProps(nextProps) { //eslint-disable-line
      this.setState(state =>
        update(state, {
          pageInfo: {
            page: { $set: nextProps.pagination.pageNumber },
            count: { $set: nextProps.pagination.totalPages },
            size: { $set: nextProps.pagination.size },
            sortList: {
              $set:
                nextProps.lastSort && nextProps.lastSort.headerName !== ''
                  ? [
                      `${nextProps.lastSort.headerName},${nextProps.lastSort.direction}`,
                    ]
                  : state.pageInfo.sortList || [],
            },
          },
        }),
      )
    }

    onChangeSize(changedSize) {
      const pageInfo = update(this.state.pageInfo, {
        page: { $set: 0 },
        size: { $set: changedSize },
      })

      this.updateStateAndLoadData(pageInfo)
    }

    onPrev() {
      if (this.state.pageInfo.page !== 0) {
        const pageInfo = update(this.state.pageInfo, {
          page: { $set: this.state.pageInfo.page - 1 },
        })

        this.updateStateAndLoadData(pageInfo)
      }
    }

    onNext() {
      if (this.state.pageInfo.page + 1 < this.state.pageInfo.count) {
        const pageInfo = update(this.state.pageInfo, {
          page: { $set: this.state.pageInfo.page + 1 },
        })
        this.updateStateAndLoadData(pageInfo)
      }
    }

    onChangePage(changedPage) {
      const pageInfo = update(this.state.pageInfo, {
        page: { $set: changedPage },
      })

      this.updateStateAndLoadData(pageInfo)
    }

    onChangeSortPriority(columnName, direction) {
      const sortList = [`${columnName},${direction}`]

      const pageInfo = update(this.state.pageInfo, {
        page: { $set: 0 },
        sortList: { $set: sortList },
      })

      this.updateStateAndLoadData(pageInfo)
    }

    updateStateAndLoadData(pageInfo) {
      this.setState(
        state =>
          update(state, {
            pageInfo: { $merge: pageInfo },
          }),
        () => {
          this.props.onLoadPagingData(pageInfo)
        },
      )
    }

    render() {
      return (
        <WrappedComponent
          onChangeSize={changedSize => this.onChangeSize(changedSize)}
          onPrev={() => this.onPrev()}
          onNext={() => this.onNext()}
          onChange={changedPage => this.onChangePage(changedPage)}
          onChangeSortPriority={(columnName, direction) =>
            this.onChangeSortPriority(columnName, direction)
          }
          {...this.props}
        />
      )
    }
  }
}

export default pageableTable
